var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.online)?_c('div',{staticClass:"online-status-dote",class:[_vm.size, { online: _vm.online }]}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }